import * as Sentry from '@sentry/react'

import ReactDOM from 'react-dom/client'

import App from './App'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  enabled: import.meta.env.PROD,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'dev',
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.01,
  sendDefaultPii: true,
})

const root = document.getElementById('root')
if (!root) {
  throw new Error('Приложение не может найти ROOT')
}

ReactDOM.createRoot(root).render(<App />)
